import { Avatar, Dialog, DialogContent, DialogTitle, Divider, Grid, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, makeStyles } from '@material-ui/core';
import { AccountBalance, CalendarToday, Close, Code, Email, FileCopy, Fingerprint, FlipToBackRounded, Money, OpenInNew, Star, TransferWithinAStation, Visibility } from '@material-ui/icons';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Toastr from "toastr";
import _ from "underscore";
import { getTransactionUrl } from '../../helpers/utility';
import { fetchRechargesRequest } from '../../store/plan/plan.actions';
import { getRecharges } from '../../store/plan/plan.selector';
import Loader from '../base/loader';
import TitleBar from '../base/TitleBar';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function RechargeContainer() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [selectedItem, setSelecteItem] = React.useState({});
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        dispatch(fetchRechargesRequest("Approved"))
    }, [])

    const { recharges, isLoading } = useSelector((state) => {
        return {
            recharges: getRecharges(state),
            isLoading: state.TransactionReducer.isLoading
        }
    }, []);

    const actionRenderer = () => {
        return ({
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                customBodyRender: (value) => {
                    let dep = _.find(recharges, x => x._id === value);
                    return (
                        <Visibility
                            className={classes.icon}
                            color="secondary"
                            onClick={() => {
                                setOpen(true);
                                setSelecteItem(dep);
                            }}
                        />
                    );
                }
            }
        });
    };


    const columns = [
        {
            name: 'createdAt',
            label: 'Transaction Date',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'createdBy',
            label: 'User',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'rechargeType',
            label: 'Type',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'rechargeAmount',
            label: 'Amount',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'coins',
            label: 'Coins',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: 'hasValue',
            label: 'Charge',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: 'status',
            label: 'Status',
            options: {
                filter: true,
                sort: true,
            }
        },
        actionRenderer()
    ];

    const datum = _.sortBy(recharges, t => moment(t.createdAt).unix).reverse().map((item) => {
        return {
            id: item._id,
            createdBy: item.createdBy,
            createdAt: moment(item.createdAt).format("DD-MM-YYYY"),
            coins: (item.method === "USDT" ? item.coins : item.amount) + ' ' + (item.isToken ? item.tokenSymbol : item.coinType),
            tokens: item.transactionTokens + ' ' + item.tokenSymbol,
            transactionCharge: item.transactionCharge + ' ' + item.coinType,
            coinType: item.isToken ? item.tokenSymbol : item.coinType,
            transactionhash: item.transactionhash,
            hasValue: item.transactionhash ? "Yes" : "No",
            receiveHash: item.receiveHash,
            status: item.status,
            rechargeAmount: item.rechargeAmount,
            rechargeType: item.rechargeType
        };
    });

    const options = {
        selectableRows: false
    };

    return (
        <div className='m-2 pb-4'>
            {
                isLoading && <Loader />
            }
            <Dialog maxWidth="md" fullWidth open={open} onClose={() => {
                setOpen(false)
            }}>
                <DialogTitle>
                    Recharge Transaction <Close className='mt-1 float-right' onClick={() => setOpen(false)} />
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Fingerprint /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.referenceNo} secondary={"Reference No"} />
                                <ListItemSecondaryAction>
                                    <FileCopy color="secondary" onClick={() => {
                                        navigator.clipboard.writeText(selectedItem.referenceNo);
                                        Toastr.info("copied to clipboard");
                                    }} />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><TransferWithinAStation /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.transactionId} secondary={"Transaction ID"} />
                                <ListItemSecondaryAction>
                                    <FileCopy color="secondary" onClick={() => {
                                        navigator.clipboard.writeText(selectedItem.transactionId);
                                        Toastr.info("copied to clipboard");
                                    }} />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Money /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.amount + " " + (selectedItem.isToken ? selectedItem.tokenSymbol : selectedItem.coinType)} secondary={"Amount"} />
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><CalendarToday /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={moment(selectedItem.createdAt).format("lll")} secondary={"Transaction Date"} />
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Email /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.userEmail && selectedItem.userEmail} secondary={"Email"} />
                                <ListItemSecondaryAction>
                                    <FileCopy color="secondary" onClick={() => {
                                        navigator.clipboard.writeText(selectedItem.userEmail);
                                        Toastr.info("copied to clipboard");
                                    }} />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><FlipToBackRounded /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.createdBy} secondary={"Created By"} />
                            </ListItem>
                        </Grid>
                        {
                            selectedItem.coinType &&
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar className='bg-success'><Code /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={selectedItem.transactionhash} secondary={"Transaction Hash"} />
                                    <ListItemSecondaryAction>
                                        <a target='_blank' href={getTransactionUrl(selectedItem.coinType) + selectedItem.transactionhash}>
                                            <OpenInNew />
                                        </a>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </Grid>
                        }
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Star /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.status} secondary={"Status"} />
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Star /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.rechargeNumber} secondary={"Number"} />
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Star /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.rechargeType} secondary={"Recharge Type"} />
                            </ListItem>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <TitleBar heading="Recharge Transactions" secondary={""}
                icon={<AccountBalance />} />
            <div className={classes.root}>
                <MUIDataTable
                    title={"Recharge Transactions List"}
                    data={datum}
                    columns={columns}
                    options={options}
                />
            </div>
        </div >
    );
}

